import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { InspectionDetailsComponent } from './inspection-details/inspection-details.component';
import { InspectionPrintPreviewDialogComponent } from './inspection-print-preview-dialog/inspection-print-preview-dialog.component';
import { InspectionsRoutingModule } from './inspections-routing.module';
import { SelectInspectionDialogComponent } from './select-inspection-dialog/select-inspection-dialog.component';
import { InspectionDataService } from './inspection-data.service';
import { AerosolShutdownComponent } from './shared/aerosol-shutdown/aerosol-shutdown.component';
import { AirConditioningAndVentilationSystemsComponent } from './shared/air-conditioning-and-ventilation-systems/air-conditioning-and-ventilation-systems.component';
import { CheckAlarmsCaseComponent } from './shared/check-alarms-case/check-alarms-case.component';
import { CheckBasicCaseComponent } from './shared/check-basic-case/check-basic-case.component';
import { CheckBasicSelectCaseComponent } from './shared/check-basic-select-case/check-basic-select-case.component';
import { CheckCapacityCaseComponent } from './shared/check-capacity-case/check-capacity-case.component';
import { CheckDialRiskCaseComponent } from './shared/check-dial-risk-case/check-dial-risk-case.component';
import { CheckDimensionsCaseComponent } from './shared/check-dimensions-case/check-dimensions-case.component';
import { CheckNotesComponent } from './shared/check-notes/check-notes.component';
import { CheckPercentageCaseComponent } from './shared/check-percentage-case/check-percentage-case.component';
import { CheckPreactionSystemCaseComponent } from './shared/check-preaction-system-case/check-preaction-system-case.component';
import { CheckRiskLevelsCaseComponent } from './shared/check-risk-levels-case/check-risk-levels-case.component';
import { CheckShutdownPumpDetailsCaseComponent } from './shared/check-shutdown-pump-details-case/check-shutdown-pump-details-case';
import { CheckSummaryNotesComponent } from './shared/check-summary-notes/check-summary-notes.component';
import { CheckTimeCaseComponent } from './shared/check-time-case/check-time-case.component';
import { CheckValueCaseComponent } from './shared/check-value-case/check-value-case.component';
import { CheckWaterCharacteristicsCaseComponent } from './shared/check-water-characteristics-case/check-water-characteristics-case.component';
import { CheckWaterFlowCaseComponent } from './shared/check-water-flow-case/check-water-flow-case.component';
import { CheckZCoefficientCaseComponent } from './shared/check-z-coefficient-case/check-z-coefficient-case.component';
import { FireAlarmComponentsComponent } from './shared/fire-alarm-components/fire-alarm-components.component';
import { FireAlarmSystemComponent } from './shared/fire-alarm-system/fire-alarm-system.component';
import { FireExtinguishersComponent } from './shared/fire-extinguishers/fire-extinguishers.component';
import { FireTapsComponent } from './shared/fire-taps/fire-taps.component';
import { GasExtinguishingSystemComponent } from './shared/gas-extinguishing-system/gas-extinguishing-system.component';
import { IntegrationPlansComponent } from './shared/integration-plans/integration-plans.component';
import { IntegrationComponent } from './shared/integration/integration.component';
import { PlansComponent } from './shared/plans/plans.component';
import { PressureSystemInStairwellsCompatibilityCheckComponent } from './shared/pressure-system-in-stairwells-compatibility-check/pressure-system-in-stairwells-compatibility-check.component';
import { PumpRoomDesignInspectionComponent } from './shared/pump-room-design-inspection/pump-room-design-inspection.component';
import { PumpRoomInstallationInspectionComponent } from './shared/pump-room-installation-inspection/pump-room-installation-inspection.component';
import { SprinklerSystemDesignInspectionComponent } from './shared/sprinkler-system-design-inspection/sprinkler-system-design-inspection.component';
import { SprinklerSystemInstallationInspectionComponent } from './shared/sprinkler-system-installation-inspection/sprinkler-system-installation-inspection.component';
import { VentilationSystemAndFireProtectionInCommercialCookingSystemsComponent } from './shared/ventilation-system-and-fire-protection-in-commercial-cooking-systems/ventilation-system-and-fire-protection-in-commercial-cooking-systems.component';
import { WaterNetworkCharacterizationInspectionComponent } from './shared/water-network-characterization-inspection/water-network-characterization-inspection.component';
import { ActivationRegimeComponent } from './shared/activation-regime/activation-regime.component';
import { InspectionDraftComponent } from './inspection-draft/inspection-draft.component';
import { DrawableFieldDirective } from './inspection-draft/directives/drawable-field.directive';
import { DraftRecognitionDialogComponent } from './draft-recognition-dialog/draft-recognition-dialog.component';
import { DraftToolbarComponent } from './inspection-draft/components/draft-toolbar/draft-toolbar.component';
import { DraftFieldIndicatorComponent } from './shared/draft-field-indicator/draft-field-indicator.component';

@NgModule({
  declarations: [
    InspectionDetailsComponent,
    InspectionDraftComponent,
    DrawableFieldDirective,
    DraftToolbarComponent,
    DraftRecognitionDialogComponent,
    DraftFieldIndicatorComponent,
    CheckBasicCaseComponent,
    SprinklerSystemDesignInspectionComponent,
    PumpRoomDesignInspectionComponent,
    SprinklerSystemInstallationInspectionComponent,
    CheckWaterCharacteristicsCaseComponent,
    CheckCapacityCaseComponent,
    CheckPreactionSystemCaseComponent,
    CheckTimeCaseComponent,
    CheckZCoefficientCaseComponent,
    PumpRoomInstallationInspectionComponent,
    CheckAlarmsCaseComponent,
    CheckPercentageCaseComponent,
    CheckRiskLevelsCaseComponent,
    PlansComponent,
    IntegrationPlansComponent,
    WaterNetworkCharacterizationInspectionComponent,
    CheckWaterFlowCaseComponent,
    CheckNotesComponent,
    CheckShutdownPumpDetailsCaseComponent,
    CheckSummaryNotesComponent,
    CheckValueCaseComponent,
    SelectInspectionDialogComponent,
    GasExtinguishingSystemComponent,
    CheckBasicSelectCaseComponent,
    CheckDimensionsCaseComponent,
    FireTapsComponent,
    FireExtinguishersComponent,
    AerosolShutdownComponent,
    FireAlarmSystemComponent,
    FireAlarmComponentsComponent,
    CheckDialRiskCaseComponent,
    AirConditioningAndVentilationSystemsComponent,
    VentilationSystemAndFireProtectionInCommercialCookingSystemsComponent,
    PressureSystemInStairwellsCompatibilityCheckComponent,
    InspectionPrintPreviewDialogComponent,
    IntegrationComponent,
    ActivationRegimeComponent
  ],
  imports: [
    SharedModule,
    InspectionsRoutingModule,
    DragDropModule,
    TranslocoRootModule
  ],
  providers: [InspectionDataService],
  exports: [
    InspectionDetailsComponent,
    InspectionDraftComponent,
    DrawableFieldDirective,
    DraftToolbarComponent,
    DraftFieldIndicatorComponent,
    CheckBasicCaseComponent,
    SprinklerSystemDesignInspectionComponent,
    PumpRoomDesignInspectionComponent,
    SprinklerSystemInstallationInspectionComponent,
    CheckWaterCharacteristicsCaseComponent,
    CheckCapacityCaseComponent,
    CheckPreactionSystemCaseComponent,
    CheckTimeCaseComponent,
    CheckZCoefficientCaseComponent,
    PumpRoomInstallationInspectionComponent,
    CheckAlarmsCaseComponent,
    CheckPercentageCaseComponent,
    CheckRiskLevelsCaseComponent,
    PlansComponent,
    IntegrationPlansComponent,
    WaterNetworkCharacterizationInspectionComponent,
    CheckWaterFlowCaseComponent,
    CheckNotesComponent,
    CheckShutdownPumpDetailsCaseComponent,
    CheckSummaryNotesComponent,
    CheckValueCaseComponent,
    SelectInspectionDialogComponent,
    GasExtinguishingSystemComponent,
    CheckBasicSelectCaseComponent,
    CheckDimensionsCaseComponent,
    FireTapsComponent,
    FireExtinguishersComponent,
    AerosolShutdownComponent,
    FireAlarmSystemComponent,
    FireAlarmComponentsComponent,
    CheckDialRiskCaseComponent,
    AirConditioningAndVentilationSystemsComponent,
    VentilationSystemAndFireProtectionInCommercialCookingSystemsComponent,
    PressureSystemInStairwellsCompatibilityCheckComponent,
    InspectionPrintPreviewDialogComponent,
    IntegrationComponent,
    ActivationRegimeComponent
  ]
})
export class InspectionsModule {}
